<div class="modal-box bg-base-100 w-full max-w-2xl overflow-hidden rounded-2xl p-0 shadow-2xl">
	<!-- Header -->
	<div class="bg-base-200/50 border-base-200 flex items-center justify-between border-b px-6 py-4">
		<h3 class="flex items-center gap-2 text-xl font-bold">
			<span [translate]>Share Resource</span>
		</h3>
		<button
			(click)="close()"
			class="btn btn-sm btn-circle btn-ghost"
		>
			✕
		</button>
	</div>

	<!-- Content -->
	<div class="p-6">
		<lib-access-table
			[resourceId]="data.resourceId"
			[resourceKind]="data.resourceKind"
			[hideAnonymous]="data.hideAnonymous ?? false"
		></lib-access-table>
	</div>

	<!-- Footer -->
	<div class="bg-base-200/50 border-base-200 flex justify-end gap-2 border-t px-6 py-4">
		<button
			class="btn btn-primary"
			(click)="close()"
			[translate]
		>
			Close
		</button>
	</div>
</div>
